import {Component} from 'react'
import {connect} from 'react-redux'
import {Link, withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'

import Phone from '../Freelance/Component/Phone/Phone.jsx'

import conf from '../../conf.js'
import {generate} from '../../routes.js'

import './SubscribeBanner.scss'

class SubscribeBanner extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    offer: PropTypes.object,
    search: PropTypes.func,
    target: PropTypes.string.isRequired,
  }

  static defaultProps = {
    currentUser: null,
    offer: null,
    search: null,
  }

  createLoginLink = () => {
    return <Link
      className="btn btn-primary"
      to={{
        pathname: '/login',
        state: {redirectTo: this.props.location.pathname}
      }}
    >
      connecter
    </Link>
  }

  createRegisterLink = () => {
    return <Link
      className="btn btn-primary"
      to={generate({name: `register-${this.props.target === conf.search.targets.freelances ? 'do' : 'freelance'}`})}
    >
      inscrire
    </Link>
  }

  changeSearchUniverse = (e, universeId) => {
    e.preventDefault()
    this.props.search({universe: universeId})
  }

  render() {
    const {currentUniverseId, currentUser, target} = this.props

    if (target === conf.search.targets.freelances && !currentUser) {
      return (
        <div className="subscribe-banner">
          Pour accéder aux profils complets et aux filtres de recherche,
          veuillez vous {this.createRegisterLink()} ou vous {this.createLoginLink()}<br/>
          Vous cherchez plus de profils? D'autres profils disponibles au <Phone user={this.props.user}/> !
        </div>
      )
    }

    if (target === conf.search.targets.offers) {
      if (null !== currentUser && !currentUser?.complete) {
        return (
          <div className="subscribe-banner">
            Il vous faut finaliser votre profil pour avoir accès aux missions en cours. Seules les missions passées
            vous sont accessibles pour l'exemple.
          </div>
        )
      }

      if (null !== currentUser && !currentUser.isAdmin && null !== currentUniverseId && currentUser.mainUniverse !== currentUniverseId && null !== this.props.search) {
        const universeName = this.props.universes.filter((universe) => {
          return universe.id === currentUniverseId
        })[0].name
        const mainUniverse = this.props.universes.filter((universe) => {
          return universe.id === currentUser.mainUniverse
        })[0]
        return (
          <div className="subscribe-banner">
            Vous n'avez pas accès aux missions {universeName} !<button
              onClick={(event) => this.changeSearchUniverse(event, mainUniverse.id)}
              className="btn btn-primary btn-sm ml-3">Voir les missions {mainUniverse.name}</button>
          </div>
        )
      }

      if (null === currentUser) {
        return (
          <div className="subscribe-banner">
            Seules les missions passées vous sont accessibles pour l'exemple. Pour avoir accès aux missions en cours,
            veuillez vous {this.createRegisterLink()} ou vous {this.createLoginLink()}
          </div>
        )
      }
    }

    return null
  }
}

export default connect(
  (state) => ({
    currentUniverseId: state.universe?.currentUniverse.id ?? null,
    universes: state.universe.universes
  }),
)(withRouter(SubscribeBanner))
